import {
    Instructions,
    GenericChoiceTest,
    ContrastTest,
    GenericSwipeTest,
    Intro,
    Outro,
} from '../containers';

import { IMainStep } from '../types';
import {
    visualAcuityTestSteps,
    astigmatismTestSteps,
    macularDegenerationTestSteps,
    backgroundQuestionsSteps,
} from '.';

const animationBasePath = process.env.REACT_APP_ANIMATION_BASE_PATH;

interface ISteps {
    [key: string]: IMainStep[];
}

export const steps: ISteps = {
    instructions: [
        {
            component: Instructions,
        },
    ],
    visualAcuity: [
        {
            component: Intro,
            props: {
                stepDisplayNumber: 2,
                backButtonStepNumber: 1,
                animationUrl: `${animationBasePath}/visualAcuityVideo.gif`,
                headerText:
                    'We beginnen met een aantal vragen over je <strong>kijkgedrag.</strong> Ben je er klaar voor?',
                tooltipText: `We doen nu de Landolt C test om je gezichtsscherpte voor veraf te
                testen met beide ogen.
                `,
            },
        },
        {
            component: GenericChoiceTest,
            props: {
                stepDisplayNumber: 2,
                stepCounterName: 'visualAcuity',
                testResultName: 'visualAcuityTestResult',
                testDisplayName: 'visualAcuity',
                steps: visualAcuityTestSteps,
            },
        },
    ],
    contrast: [
        {
            component: ContrastTest,
            props: {
                stepDisplayNumber: 3,
            },
        },
    ],
    astigmatism: [
        {
            component: GenericChoiceTest,
            props: {
                stepDisplayNumber: 4,
                stepCounterName: 'astigmatism',
                testResultName: 'astigmatismTestPassed',
                testDisplayName: 'Cilinderafwijking (astigmatisme)',
                steps: astigmatismTestSteps,
            },
        },
    ],
    macularDegeneration: [
        {
            component: GenericChoiceTest,
            props: {
                stepDisplayNumber: 5,
                stepCounterName: 'macularDegeneration',
                testResultName: 'macularDegenerationTestPassed',
                testDisplayName: 'centraal gezichtsveld',
                steps: macularDegenerationTestSteps,
            },
        },
    ],
    backgroundQuestions: [
        {
            component: Intro,
            props: {
                stepDisplayNumber: 6,
                backButtonStepNumber: 12,
                headerText:
                    'Nu gaan we wat dieper in op jouw <strong>lifestyle.</strong> Ben je er klaar voor?',
            },
        },
        {
            component: GenericSwipeTest,
            props: {
                stepCounterName: 'backgroundQuestions',
                steps: backgroundQuestionsSteps,
                stepDisplayNumber: 6,
            },
        },
        {
            component: Outro,
            props: {
                stepDisplayNumber: 6,
                headerText:
                    'Alle vragen beantwoord. <strong>Helemaal klaar!</strong>',
            },
        },
    ],
};
